import { render } from "./CommentBox.vue?vue&type=template&id=871b64be"
import script from "./CommentBox.vue?vue&type=script&lang=ts"
export * from "./CommentBox.vue?vue&type=script&lang=ts"
script.render = render

export default script